export const TrifoldMapIcon = ({ className, width='16', height='16'}) => {
  return (
    <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_2792_53413)">
      <path
        d="M6 11.5V2.5"
        stroke="currentColor"
        strokeWidth={0.9375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4.5V13.5"
        stroke="currentColor"
        strokeWidth={0.9375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11.5L2 12.5V3.5L6 2.5L10 4.5L14 3.5V12.5L10 13.5L6 11.5Z"
        stroke="currentColor"
        strokeWidth={0.9375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2792_53413">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
  );
};
